import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';
import { InputTextModule } from 'primeng/inputtext';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PanelModule } from 'primeng/panel';
import { CheckboxModule } from 'primeng/checkbox';

import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { TagModule } from 'primeng/tag';
import { InputTextarea } from 'primeng/inputtextarea';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';
import { CoreModule } from 'src/app/core/core.module';
import { RatingModule } from 'primeng/rating';
import { VehiclesModule } from '../vehicles/vehicles.module';
import { PasswordModule } from 'primeng/password';
import { FileUploadModule } from 'primeng/fileupload';
import { ZonesListComponent } from './zones-list/zones-list.component';
import { ZonesDetailComponent } from './zones-detail/zones-detail.component';
import { ZonesRoutingModule } from './zones-routing.module';
import { ZonesLineComponent } from './zones-detail/zones-line/zones-line.component';
import { ZonesUploadExcelComponent } from './zones-detail/zones-upload-excel/zones-upload-excel.component';


@NgModule({ declarations: [
        ZonesListComponent,
        ZonesDetailComponent,
        ZonesLineComponent,
        ZonesUploadExcelComponent
    ], imports: [ZonesRoutingModule,
        MessagesModule,
        CoreModule,
        BrowserModule,
        ReactiveFormsModule,
        FormsModule,
        TableModule,
        CardModule,
        ButtonModule,
        InputTextModule,
        InputNumberModule,
        InputSwitchModule,
        DropdownModule,
        ConfirmDialogModule,
        PanelModule,
        CheckboxModule,
        TabViewModule,
        CalendarModule,
        TagModule,
        InputTextarea,
        DropdownModule,
        DialogModule,
        EditorModule,
        RatingModule,
        VehiclesModule,
        PasswordModule,
        FileUploadModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class ZonesModule { }